import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  isDeliveryNewVerison: false,
  balanceDetailData: {
    startTime: '',
    endTime: '',
    bizType: -1,
    storeIds: []
  },
  mapAddressInfo: {
    provinceName: '',
    provinceCode: '',
    cityName: '',
    cityCode: '',
    countyName: '',
    countyCode: '',
    storeLng: '',
    storeLat: '',
    address: '',
    storeArea: ''
  },
  cancelReasonList: [] // 取消配送原因列表
}
const mutations = {
  [types.SET_BALANCE_CONDITION] (state, data) {
    console.log(data.storeId)
    state.balanceDetailData.startTime = data.startTime
    state.balanceDetailData.endTime = data.endTime
    state.balanceDetailData.bizType = data.bizType
    state.balanceDetailData.storeIds = data.storeIds.slice()
  },
  [types.SET_MAP_ADDRESS_INFO] (state, data) {
    state.mapAddressInfo = data
  },
  [types.SET_DELIVERY_VERSION] (state, data) {
    state.isDeliveryNewVerison = data
  },
  setCancelReasonList (state, data) {
    state.cancelReasonList = data
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
